export const exchangeAction={
    SAVEPASSENGER:"SAVEPASSENGER",
    SAVEFLIGHTSEARCH:"SAVEFLIGHTSEARCH",
    SAVEFLIGHTEXTRAINFO:"SAVEFLIGHTEXTRAINFO",
    SAVEFLIGHTSEARCHRESULT:"SAVEFLIGHTSEARCHRESULT",
    SAVEFLIGHTSELECTIONRESULT:"SAVEFLIGHTSELECTIONRESULT",
    SAVeFLIGHTSEARCHRFORCONFIRMATION:"SAVeFLIGHTSEARCHFORCONFIRMATION",
    SAVEORIGINALPAYMENT:"SAVEORIGINALPAYMENT"
}